<template>
    <div class='text-left mini-padding'>
        <v-data-table
            :headers="tableHeaders"
            :items="pedidos || []"
            sort-by="name"
            class="elevation-4 tableCalls"
            :loading="this.loading"
            :loading-text="labels.textLoading"
            :no-data-text="labels.textNoData"
            v-resize="onResize"
            :search="search"
            dense
            :items-per-page=50
            :footer-props="{
                'items-per-page-text': labels.itemsPerPage,
                showFirstLastpage:true,
                'items-per-page-options':[10, 50, 100, -1]
            }"
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <div style="width:100%; display: flex; height: inherit;">
                        <div style="width:30%; display: flex; align-items: center;">
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                :label="labels.buscar"
                                single-line
                                hide-details
                            ></v-text-field>
                        </div>
                        <v-divider
                            class="mx-4"
                            inset
                            vertical
                        />
                        <div style="width:66%; display: flex;">
                            <div style="display: flex; align-items: center;">
                                <v-btn class="btnFilter" icon @click.stop="changeFilterDrawerWidth">
                                    <v-icon>
                                        mdi-filter-plus
                                    </v-icon>
                                </v-btn>
                            </div>
                            <div class="filtersColumn">
                                <v-chip
                                    v-for="filter in filterValues"
                                    :key="filter.value.ID"
                                    style="margin:1px;"
                                >
                                    <span style="padding: 0px !important;" class="pr-2 noCloseFilters">
                                        {{ filter.title+': ' + (filter.value.NOME || filter.value.ID || filter.value) }}
                                    </span>
                                    <v-btn
                                        style="position: relative; right: -16px;"
                                        icon
                                        @click="removeFilterAndGetCalls(filter)"
                                    >
                                        <v-icon color="red">
                                            mdi-close-circle
                                        </v-icon>
                                    </v-btn>
                                </v-chip>
                            </div>
                        </div>
                    </div>
                </v-toolbar>
                <v-divider></v-divider>
            </template>
            <template v-slot:[`item.DATA_CADASTRO`]="{ item }">
                <span>{{ item.DATA_CADASTRO ? moment(item.DATA_CADASTRO).format('DD/MM/YYYY') : '' }}</span>
            </template>
            <template v-slot:[`item.ID`]="{ item }">
                <div class="labelBadge">
                    <div class="badge" v-if="item.noViews">
                        <span>{{item.noViews}}</span>
                    </div>
                    <span style=" margin-left:-22px;">{{item.ID}}</span>
                </div>
            </template>
            <template v-slot:[`item.ASSUNTO`]="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <div 
                            class="text-truncate assuntoColumn"
                            v-bind="attrs"
                            v-on="on"
                        >
                            {{ item.ASSUNTO }}
                        </div>
                    </template>
                    <span>{{ item.ASSUNTO }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.SITUACAO`]="{ item }">
                <span>
                     {{item.SITUACAO | translate('PedidosTable')}}
                </span>
            </template>
            <template v-slot:[`item.CLIENTE`]="{ item }">
                <span >{{item.CLIENTE}}</span>
            </template>
            <template v-slot:[`item.ACAO_COM_IMAGEM_PERFIL`]="{ item }">
                <v-avatar
                    class="avatar"
                    size="40px"
                >
                    <img
                        alt="Avatar"
                        width="40"
                        height="40"
                        :src="getAvatarimage(item.ACAO_COM_IMAGEM_PERFIL)"
                    >
                </v-avatar>
                <span>{{item.RESPONSAVEL}}</span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-row>
                    <v-col class="actionButtons">
                        <v-btn 
                            icon 
                            @click="goToOrder(item)"
                        >
                            <v-icon
                                color="#1976d2"
                            >
                                mdi-chevron-right
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:[`footer.page-text`]="items">
                <span style="font-weight: bolder;">{{items.pageStop}}</span> de {{items.itemsLength}}
            </template>
        </v-data-table>

        <!--                                                     toggle drawer                                                   -->

        <v-navigation-drawer
            class="filtersDrawer"
            v-model="filterDrawer"
            fixed
            permanent
            right
            :width="filterDrawerWidth"
            v-resize="onResize"
            v-click-outside="closeDrawer"
            @mousedown="''"
            color="#ececec"
            app
        >
                <v-list style="padding: 10px;">
                    <v-list-item disabled>
                        <v-list-item-icon>
                            <v-icon large>
                                mdi-filter
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;">
                            <v-list-item-title class="text-left">
                                {{'Filtros' | translate('AtendimentosTable')}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider/>
                <v-list class="filtersBody">
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;" v-if="!!filters.ID">
                            <v-combobox
                                    class="noCloseFilters"
                                    dense
                                    v-model="filters.ID.values"
                                    :items="filterOptions.orders"
                                    :label="filters.ID.title"
                                    item-text="ID"
                                    item-value="ID"
                                    hide-selected
                                    chips
                                    multiple
                                    :menu-props="{closeOnContentClick:true}"
                                >
                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                        <v-chip
                                            :key="JSON.stringify(item.ID)"
                                            v-if="item === Object(item)"
                                            v-bind="attrs"
                                            :input-value="selected.value"
                                            @click:close="parent.selectItem(item.value)"
                                            class="kndChip"
                                        >
                                            <span class="pr-2 noCloseFilters">
                                                {{ 'Nº: ' + item.ID }}
                                            </span>
                                            <v-btn
                                                icon
                                                @click="parent.selectItem(item)"
                                            >
                                                <v-icon color="red">
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-btn>
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item`]="{ item }">
                                        <span class="pr-2 noCloseFilters">
                                            {{ 'Nº: ' + item.ID }}
                                        </span>
                                    </template>
                                    <template v-slot:no-data>
                                        <span> </span>
                                    </template>
                                </v-combobox>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;" v-if="!!filters.CLIENTE_ID">
                            <v-combobox
                                    class="noCloseFilters"
                                    dense
                                    v-model="filters.CLIENTE_ID.values"
                                    :items="filterOptions.clients"
                                    :label="filters.CLIENTE_ID.title"
                                    item-text="NOME"
                                    item-value="ID"
                                    hide-selected
                                    return-object
                                    chips
                                    multiple
                                    :disabled="!!user.CLIENTE_ID"
                                    :menu-props="{closeOnContentClick:true}"
                            >
                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                        <v-chip
                                            :key="JSON.stringify(item.ID)"
                                            v-if="item === Object(item)"
                                            v-bind="attrs"
                                            :input-value="selected.value"
                                            @click:close="parent.selectItem(item.value)"
                                            class="kndChip"
                                        >
                                            <v-avatar 
                                                size="22"
                                                style="margin-right:5px;"  
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            <span class="pr-2 noCloseFilters">
                                                {{ item.NOME }}
                                            </span>
                                            <v-btn
                                                icon
                                                @click="parent.selectItem(item)"
                                            >
                                                <v-icon color="red">
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-btn>
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item`]="{ item }">
                                        <v-avatar 
                                            class="noCloseFilters"
                                            size="22" 
                                            style="margin-right:5px;"  
                                        >
                                            <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                        </v-avatar>
                                        <span class="pr-2 noCloseFilters">
                                            {{ item.NOME }}
                                        </span>
                                    </template>
                                    <template v-slot:no-data>
                                        <span> </span>
                                    </template>
                                </v-combobox>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;">
                            <date-picker v-model="filters.DATA_INICIO.values[0]" :placeholder="labels.data_inicio_de" format="DD/MM/YYYY" valueType="format" style="width: 100%; margin: 15px 0px;"/>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;">
                            <date-picker v-if="enableDate()" v-model="filters.DATA_INICIO.values[1]" :placeholder="labels.data_inicio_ate" format="DD/MM/YYYY" valueType="format" style="width: 100%; margin: 15px 0px;" />
                            <date-picker v-else v-model="filters.DATA_INICIO.values[1]" :placeholder="labels.data_inicio_ate" format="DD/MM/YYYY" valueType="format" style="width: 100%; margin: 15px 0px;" disabled />
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;" v-if="!!filters.RESPONSAVEL_ID">
                            <v-combobox
                                    class="noCloseFilters"
                                    dense
                                    v-model="filters.RESPONSAVEL_ID.values"
                                    :items="filterOptions.responsibles"
                                    :label="filters.RESPONSAVEL_ID.title"
                                    item-text="RESPONSAVEL"
                                    item-value="RESPONSAVEL"
                                    hide-selected
                                    return-object
                                    chips
                                    multiple
                                    :menu-props="{closeOnContentClick:true}"
                                >
                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                        <v-chip
                                            :key="JSON.stringify(item.ID)"
                                            v-if="item === Object(item)"
                                            v-bind="attrs"
                                            :input-value="selected.value"
                                            @click:close="parent.selectItem(item.value)"
                                            class="kndChip"
                                        >
                                            <v-avatar 
                                                size="22"
                                                style="margin-right:5px;"  
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            <span class="pr-2 noCloseFilters">
                                                {{ item.RESPONSAVEL }}
                                            </span>
                                            <v-btn
                                                icon
                                                @click="parent.selectItem(item)"
                                            >
                                                <v-icon color="red">
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-btn>
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item`]="{ item }">
                                        <v-avatar 
                                            class="noCloseFilters"
                                            size="22" 
                                            style="margin-right:5px;"  
                                        >
                                            <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                        </v-avatar>
                                        <span class="pr-2 noCloseFilters">
                                            {{ item.RESPONSAVEL }}
                                        </span>
                                    </template>
                                    <template v-slot:no-data>
                                        <span> </span>
                                    </template>
                                </v-combobox>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="noCloseFilters">
                        <v-list-item-content class="noCloseFilters" style="padding: 10px 0px 0px 0px;" v-if="!!filters.SITUACAO_ID">
                            <v-combobox
                                class="noCloseFilters"
                                dense
                                v-model="filters.SITUACAO_ID.values"
                                :items="filterOptions.situations"
                                :label="filters.SITUACAO_ID.title"
                                item-text="NOME"
                                item-value="ID"
                                hide-selected
                                return-object
                                chips
                                multiple
                                :menu-props="{closeOnContentClick:true}"
                            >
                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                    <v-chip
                                        :key="JSON.stringify(item.ID)"
                                        v-if="item === Object(item)"
                                        v-bind="attrs"
                                        :input-value="selected.value"
                                        @click:close="parent.selectItem(item.value)"
                                        class="kndChip"
                                    >
                                        <v-avatar
                                            class="noCloseFilters"
                                            :color="item.COR"
                                            size="18"
                                            style="margin-right: 1em;"
                                        ></v-avatar>
                                        <span class="pr-2 noCloseFilters">
                                            {{ item.NOME }}
                                        </span>
                                        <v-btn
                                            icon
                                            @click="parent.selectItem(item)"
                                        >
                                            <v-icon color="red">
                                                mdi-close-circle
                                            </v-icon>
                                        </v-btn>
                                    </v-chip>
                                </template>
                                <template v-slot:[`item`]="{ item }">
                                    <v-avatar
                                        class="noCloseFilters"
                                        :color="item.COR"
                                        size="18"
                                        style="margin-right: 1em;"
                                    ></v-avatar>
                                    <span class="pr-2 noCloseFilters">
                                        {{ item.NOME }}
                                    </span>
                                </template>
                                <template v-slot:no-data>
                                    <span> </span>
                                </template>
                            </v-combobox>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider/>
                <footer class="filtersFooter">
                    <v-spacer/>
                    <v-btn 
                        class="btn1"
                        dark
                        small
                        @click="clearFilters()"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                        {{'Limpar' | translate('AtendimentosTable')}}
                    </v-btn>
                    <v-spacer/>
                    <v-btn 
                        class="btn1"
                        dark
                        small
                        @click="setFilters(filters), getAllOrders()"
                    >
                        <v-icon>
                            mdi-check
                        </v-icon>
                        {{'Aplicar' | translate('AtendimentosTable')}}
                    </v-btn>
                    <v-spacer/>
                </footer>
        </v-navigation-drawer>
    </div>
</template>

<script>
import translate from '../../../src/plugins/translate'
import getAllOrders from '../../../src/app/pedido/getAllOrders'
import DatePicker from 'vue2-datepicker'
import { createNamespacedHelpers } from 'vuex'
import getOrderSituations from '../../../src/app/situacaoPedido/getAllOrderSituations'
import loadAllResponsible from '../../../src/app/responsavelPedido/loadAllResponsible'
import getClientsByCompanyIdAndName from '../../../src/app/cliente/getClientsByCompanyIdAndName'
const user = createNamespacedHelpers('user')
const filters = createNamespacedHelpers('orderFilters')


export default {
    name: 'PedidosTable',
    components: {DatePicker},
    data() {
        return {
            loading: false,
            search: null,
            filterDrawer: false,
            filterDrawerWidth: '0px',
            labels: {
                textLoading: translate('Carregando pedidos', 'PedidosTable'),
                textNoData: translate('Nenhum registro localizado', 'PedidosTable'),
                buscar: translate('Buscar', 'PedidosTable'),
                data_inicio_de: translate('Data Cadastro De','PedidosTable'),
                data_inicio_ate: translate('Data Cadastro Até','PedidosTable'),
                itemsPerPage: translate('Itens Por Página','PedidosTable')
            },
            imageTime: new Date().getTime(),
            pedidos:[],
            tableHeaders: [
                { text: translate('Número', 'PedidosTable'), value: 'ID', width: '12%', align:'center'},
                { text: translate('N° Atendimento', 'PedidosTable'), value: 'ATENDIMENTO', width: '15%', align:'center'},
                { text: translate('Cliente', 'PedidosTable'), value: 'CLIENTE', width: '19%' },
                { text: translate('Assunto', 'PedidosTable'), value: 'ASSUNTO', width: '21%' },
                { text: translate('Data de cadastro', 'PedidosTable'), value: 'DATA_CADASTRO', width: '10%', },
                { text: translate('Consultor', 'PedidosTable'), value: 'RESPONSAVEL', width: '14%', align:'start'},
                { text: translate('Situação', 'PedidosTable'), value: 'SITUACAO', width: '14%', align:'center' },
                { text: '', value: 'actions', sortable: false, width: '4%', align:'end' }
            ],
            defaultImage: require('../../../src/assets/user.png'),
            baseUrl: process.env.VUE_APP_API_URL,
            floatingAvatarmenu: document.getElementById('floatingAvatarmenu'),
            floatingWarnings: document.getElementsByClassName('floatingMenuWarning')
        }
    },
    watch:{
        $route (){
            this.$nextTick(function(){
                this.getAllOrders()
            })
        }
    },
    computed:{
        ...user.mapGetters(['user']),
        ...filters.mapGetters(['filters']),
        ...filters.mapGetters(['filterOptions']),
        ...filters.mapGetters(['filterValues'])

    },
    methods: {
        ...filters.mapActions(['setFilters', 'setFilterOptions', 'setFilterValues']),
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        },
        async getAllOrders(noFilters) {
            this.closeDrawer()
            this.loading = true
            var binds = {allOrders:true, companyId:this.user.EMPRESA_ID, orderSituationId:this.$route.params.code, userId:this.user.USUARIO_ID, isAdmin : this.user.ADM,filters: noFilters ? null : this.filters}
            await getAllOrders(binds)
                .then(function(response){
                    if(noFilters) this.buildFilters(response.data)
                     if(this.$route.params.code === binds.orderSituationId) this.pedidos = response.data
                     this.loading = false
                }.bind(this))
            this.buildFilterValues()
        },
        buildFilters(array) {
            for(var i = 0; i < array.length; i++){
                var order = {
                    ID: array[i].ID,
                }
                if(order.ID && !this.filterOptions.orders.some(function(item){ return item.ID == order.ID })){
                    this.filterOptions.orders.push(order)
                }
              
                var situation = {
                    CODIGO: array[i].CODIGO,
                    NOME: array[i].NOME
                }
                if(situation.CODIGO && !this.filterOptions.situations.some(function(item){ return item.CODIGO == situation.CODIGO })){
                    this.filterOptions.situations.push(situation)
                }
            }
            this.setFilterOptions(this.filterOptions)
        },
         buildFiltersClients(array) {
            for(var i = 0; i < array.length; i++){
                var client = {
                    ID: array[i].ID,
                    NOME: array[i].NOME,
                    IMAGEM_PERFIL: null
                }
                if(client.ID && !this.filterOptions.clients.some(function(item){ return item.ID == client.ID})){
                    this.filterOptions.clients.push(client)
                }
            }
            this.setFilterOptions(this.filterOptions)
        },
         buildFiltersResponsibles(array) {
            for(var i = 0; i < array.length; i++){
                var responsible = {
                    RESPONSAVEL: array[i].RESPONSAVEL,
                }
                if(responsible.RESPONSAVEL && !this.filterOptions.responsibles.some(function(item){ return item.RESPONSAVEL == responsible.RESPONSAVEL})){
                    this.filterOptions.responsibles.push(responsible)
                }
            }
            this.setFilterOptions(this.filterOptions)
        },
        async getInformationForFilters(){
            await getOrderSituations().then(response => {
                this.buildFilters(response.data)
            })
            await getClientsByCompanyIdAndName({}).then(response => {
                this.buildFiltersClients(response.data)
            })
            await loadAllResponsible().then(response => {
                this.buildFiltersResponsibles(response.data)
            })
        }
        ,
        buildFilterValues() {
            this.setFilterValues([])
            var arrFilters = Object.values(this.filters)
            this.$nextTick(function(){
                for(let i = 0; i < arrFilters.length; i++){
                    for(let y = 0; y < arrFilters[i].values.length; y++){
                        if(!arrFilters[i].values[y]) continue
                        let value = {
                            title: arrFilters[i].title,
                            value: arrFilters[i].values[y]
                        }
                        if(value.title == 'Consultor') value.value.NOME = value.value.RESPONSAVEL
                        console.log(value)
                        if(!this.filterValues.some(function(item){ return JSON.stringify(item) == JSON.stringify(value)})) this.filterValues.push(value)
                    }
                }
                this.setFilterValues(this.filterValues)
            })
        },
        getAvatarimage(image) {
            return image ? this.baseUrl + image + '?t=' + this.imageTime : this.defaultImage
        },
        goToOrder(order){
            if(order) this.$router.push('/pedido/'+order.ID)
            else this.$router.push('/pedido')
        },
        changeFilterDrawerWidth() {
            if(this.filterDrawerWidth == '0px'){
                this.filterDrawerWidth = '360px'
                if(this.floatingAvatarmenu) this.floatingAvatarmenu.style.right ='368px'
                if(this.floatingWarnings && this.floatingWarnings.length) for(const fw of this.floatingWarnings) fw.style.right ='368px'
            } else {
                this.filterDrawerWidth = '0px'
                if(this.floatingAvatarmenu) this.floatingAvatarmenu.style.right ='8px'
                if(this.floatingWarnings && this.floatingWarnings.length) for(const fw of this.floatingWarnings) fw.style.right ='8px'
            }
        },
        closeDrawer(event) {
            if(event){
                if(event.target.className.includes('mdi-filter')) return
                if(event.target.className.includes('noCloseFilters')) return
                if(event.target.className.includes('v-list v-select-list v-sheet theme--light v-list--dense theme--light')) return
                if(event.target.firstElementChild && event.target.firstElementChild.className.includes('noCloseFilters')) return
                if(event.target.firstElementChild && event.target.firstElementChild.className.includes('noCloseFilters')) return
                if(event.target.parentNode) if (event.target.parentNode.className.includes('btnFilter')) return
                if(event.target.parentNode) if (event.target.parentNode.className.includes('cell')) return
                if(event.target.parentNode) if (event.target.parentNode.className.includes('mx-date-row')) return
            }
            this.filterDrawerWidth = '0px'
            if(this.floatingAvatarmenu) this.floatingAvatarmenu.style.right ='8px'
            if(this.floatingWarnings && this.floatingWarnings.length) for(const fw of this.floatingWarnings) fw.style.right ='8px'
        },
        addFilterValue(stringFilter, filter) {
            filter.values.push(stringFilter)
            filter.text = ''
        },
        clearFilters() {
            this.setFilters({
                ID:{label:'ID', title:translate('Nº', 'AtendimentosTable'), values:[]},
                CLIENTE_ID: {label:'CLIENTE_ID', title:translate('Cliente', 'AtendimentosTable'), values:[]},
                DATA_INICIO: {label:'DATA_INICIO', title:translate('Dt. Ini.', 'AtendimentosTable'), values:[]},
                RESPONSAVEL_ID: {label:'RESPONSAVEL_ID', title:translate('Consultor', 'AtendimentosTable'), values:[]},
                SITUACAO_ID: {label:'SITUACAO_ID', title:translate('Situação', 'AtendimentosTable'), values:[]}
            })
        },
        removeFilterAndGetCalls(filter){
            var arrFilters = Object.values(this.filters)
            for(let i = 0; i < arrFilters.length; i++){
                if(arrFilters[i].title == filter.title){
                    arrFilters[i].values = arrFilters[i].values.filter(function(item){
                        return item.ID != filter.value.ID
                    })
                }
                this.filters[arrFilters[i].label] = arrFilters[i]
            }
            this.filterValues = []
            this.setFilterValues([])
            this.setFilters(this.filters)
            this.getAllOrders()
        },
        enableDate(){
            return this.filters.DATA_INICIO.values[0]
        }
    },
    created() {
        this.clearFilters()
        this.setFilterValues([])
        this.setFilterOptions({
            clients: [],
            responsibles: [],
            orders: [],
            orderRequesters: [],
            orderResponsibles: [],
            situations: []
        })
    },
    async mounted() {
        this.onResize()
        this.situationId = this.$route.params.code
        await this.getAllOrders(true)
        await this.getInformationForFilters()
    }

}
</script>
<style lang="scss" scoped="true">

.elevation-4.tableCalls{
    width:99%;
}   
.btn1{
    text-transform: none !important;
}
.bodyPage{
    padding-top:8%;
}
.text-left{
    text-align: left;
}
.tableCalls{
    width: 90%;
}
.mini-padding{
    margin: 0;
    padding:8px;
}
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
.headerbuttons{
    padding-bottom: 2em;
    display: flex;
}
.marginRight{
    margin-right: 1em;
}
.assuntoColumn{
    max-width: 200px;
}
.chipSituation{
    width: 100%;
    justify-content: center;
}
.labelBadge{
    display: flex;
    position: relative;
    justify-content: center;
}
.badge{
    position: absolute;
    // margin-right: 2.8em;
    top: -8px;
    background-color: #d93025;
    width: min-content;
    height: 14px;
    border-radius: 50px;
    min-width: 14px;
    display: flex;
    // align-items: center;
    justify-content: center;
}
.badge > span{
    font-size: 10px;
    position: relative;
    color: white;
    padding: 2px;
}
.filtersDrawer{
    height: 96% !important;
}
.filtersBody{
    padding: 10px;
    height: 81%;
    scrollbar-width: thin;
    overflow: auto;
}
.filtersBody::-webkit-scrollbar {
    width: 8px;
}

.filtersBody::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.filtersBody::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.filtersFooter{
    padding: 10px;
    display: flex;

}
.filtersColumn{
    margin-left: 4px;
    padding-bottom: 2px; 
    display: inline-block; 
    align-items: center; 
    overflow-x: auto; 
    white-space: nowrap;
    height: fit-content;
    padding-top: 18px;
}
.filtersColumn::-webkit-scrollbar {
    height: 8px;
}

.filtersColumn::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.filtersColumn::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}

@media only screen and (max-width: 539px){
    .assuntoColumn{
        max-width: 40px;
    }
    .tableCalls{
        width: 100%;
    }
}
@media only screen and (min-width: 540px) and (max-width: 739px){
    .assuntoColumn{
        max-width: 100px;
    }
    .tableCalls{
        width: 100%;
    }
}
@media only screen and (min-width: 601px) and (max-width: 820px){
    .assuntoColumn{
        max-width: 160px;
    }
    .tableCalls{
        width: 100%;
    }
}
</style>